export default __webpack_public_path__ + "static/media/large.793f2e72.jpg";